import { GetFonts } from '@/connection/font-packs';
import { FetchError } from '@/connection/helpers';
import { TemplatesReducerCreator } from '../types';
import type { RootState } from '@/store/root-state';

const fetchFontPacksReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const fonts = await GetFonts(channel);
        return fonts;
      } catch (e) {
        if (e instanceof FetchError) {
          return rejectWithValue(e.message);
        }

        throw e;
      }
    },
    {
      options: {
        condition: (_, { getState }) => {
          const state = getState() as RootState;
          return !state.templates.loadingFontPacks;
        },
      },
      fulfilled: (state, action) => {
        state.fontPacks = action.payload;
      },
      pending: (state) => {
        state.loadingFontPacks = true;
      },
      rejected: (_, action) => {
        console.error(action.error);
      },
      settled: (state) => {
        state.loadingFontPacks = false;
      },
    }
  );
};

export default fetchFontPacksReducer;
